module.exports = __webpack_public_path__ + "europa-10-microprint.jpg?a0b8b0e8c06c17b62d0f5795da373cc6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-10-microprint.jpg
// module id = 245
// module chunks = 0